import React from "react";
import Page from "../../../components/general/page";
import VatReportPage from "../../../components/report/vatSettlements";

const VatReportView = props => {
  const { pageRef } = props;

  return (
    <Page
      pageRef={pageRef}
      title={"Liquidazione IVA"}
      subtitle={""}
      backUrl="/reports/home"
    >
      <VatReportPage />
    </Page>
  );
};

export default VatReportView;
